import styles from "./GovernanceHeader.module.css";

export const GovernanceHeader = (props) => {
  return (
    <div className={styles.governance_header}>
      <div className='container'>
        <h2>QUAI DAO Governance Model</h2>
      </div>
    </div>
  );
};
